import { useState } from 'react';
import { useIsomorphicLayoutEffect } from '@toss/react';
import { useSetAtom } from 'jotai';

import { ownershipAtom } from '../stores/ownershipAtom';

/** 이 화면이 내 것인지 알린다. 모르면 `null`. 길이 없을 때 좌측 메뉴·목록 버튼의 소유 기준이 된다. */
export function useDeclareOwnership(isMine: boolean | null) {
  const setOwnership = useSetAtom(ownershipAtom);
  const [owner] = useState(() => Symbol('ownership'));

  useIsomorphicLayoutEffect(() => {
    setOwnership({ owner, isMine });
    // 지금 값이 내 것일 때만 지운다.
    return () => setOwnership(cur => (cur?.owner === owner ? undefined : cur));
  }, [setOwnership, owner, isMine]);
}
